import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React, { FC } from 'react';

export const FormStageIcon: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.1429 2H3.85714C3.34286 2 3 2.35 3 2.875V13.125C3 13.65 3.34286 14 3.85714 14H12.1429C12.6571 14 13 13.65 13 13.125V2.875C13 2.35 12.6571 2 12.1429 2ZM8 11.5H5V10H8V11.5ZM10 8.5H5V7H10V8.5ZM11 5.5H5V4H11V5.5Z" />
  </SvgIcon>
);
